import { QueryClient } from '@tanstack/react-query';
import createClient from 'openapi-react-query';
import { unifiedClient, adminApiClient, appApiClient } from './unified-fetch';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
});

// Create query clients for both admin and app APIs
export const $adminApi = createClient(adminApiClient);
export const $appApi = createClient(appApiClient);

// For backward compatibility, export the admin API as the default
export const $api = $adminApi;

// Export the unified client for direct access
export { unifiedClient };
